import React from "react";
import img1 from "../../../Assets/about-us/portfolio-img-1.png";
import img2 from "../../../Assets/about-us/portfolio-img-2.png";
import img3 from "../../../Assets/about-us/portfolio-img-3.png";
import img4 from "../../../Assets/about-us/portfolio-img-4.png";
import img5 from "../../../Assets/about-us/portfolio-img-5.png";

const Portfolio = () => {
  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-6 sm:py-10 flex flex-col items-center bg-yellow-50/30">
      <div className="flex flex-col items-center justify-center text-center">
        <p className="text-[#92AD36] text-sm font-semibold tracking-wide">
          RECENTLY COMPLETED
        </p>

        <h2 className="text-2xl md:text-4xl font-serif  text-[#000000] mt-3">
          Our Latest Portfolio
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-10 w-full mt-10 gap-3 ">
        <div className="md:col-span-4">
          <img
            src={img1}
            alt=""
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        <div className="md:col-span-6 grid grid-cols-10 gap-3">
          {/* First Row */}
          <img
            src={img2}
            alt=""
            className="col-span-4 w-full h-full object-cover rounded-xl"
          />
          <img
            src={img3}
            alt=""
            className="col-span-6 w-full h-full object-cover rounded-xl"
          />

          {/* Second Row */}
          <img
            src={img4}
            alt=""
            className="col-span-6 w-full h-full object-cover rounded-xl"
          />
          <img
            src={img5}
            alt=""
            className="col-span-4 w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
